import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';

const CardiacRehabilitation = () => {
  const serviceData = {
    title: "Cardiac Rehabilitation",
    image: "/Cardiac.png",
    description: "Our cardiac rehabilitation program is designed to help patients recover from heart conditions and improve their cardiovascular health through supervised exercise, education, and lifestyle modification strategies.",
    benefits: [
      "Improved cardiovascular fitness",
      "Better heart function",
      "Reduced risk of future cardiac events",
      "Enhanced quality of life",
      "Increased energy levels",
      "Better stress management"
    ],
    approach: [
      "Cardiovascular exercise training",
      "Heart rate and blood pressure monitoring",
      "Risk factor modification",
      "Nutrition counseling",
      "Stress management techniques",
      "Educational sessions on heart health"
    ]
  };

  return <ServiceLayout {...serviceData} />;
};

export default CardiacRehabilitation; 